import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "light",
  user: undefined,
  landlord: 1,
  landlordDetails: null,
  einvoicingEnabled: false,
  token: null,
  businessTerms:{},
  posts: [],
  rental: {},
  refreshCount: 0,
  property_id: null,
  occupancy: null,
  smartDevice:null,
  years:[2024,2025,2026,2027,2028,2029,2030,2031,2032,2033,2034],
  tuyaToken: null,
  tenantPayment: null,
  currentTab: {
    financialsTab: 0,
    propertyDetailsTab:0,
    ticketsTab:0
  }
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.landlord = action.payload.landlord;
      state.landlordDetails = action.payload.landlordDetails;
      state.einvoicingEnabled = Boolean(action.payload.einvoicingEnabled);
    },
    setEinvoicingEnabled: (state, action) => {
      state.einvoicingEnabled = Boolean(action.payload);
    },
    setLogout: (state) => {
      state.user = null;
      state.token = null;
      state.landlordDetails = null;
      state.einvoicingEnabled = false;
      state.businessTerms={};
      state.currentTab = {
        financialsTab: 0,
        propertyDetailsTab:0,
        ticketsTab:0
      }
      state.years = [2024,2025,2026,2027,2028,2029,2030,2031,2032,2033,2034]
    },
    setBusinessTerms: (state, action)=>{
      state.businessTerms = action.payload
    },
    setRental: (state, action) => {
      state.rental = action.payload
    },
    setTuyaToken: (state, action) =>{
      state.tuyaToken = action.payload.result
    },
    setFriends: (state, action) => {
      if (state.user) {
        state.user.friends = action.payload.friends;
      } else {
        console.error("user friends non-existent :(");
      }
    },
    setPosts: (state, action) => {
      state.posts = action.payload.posts;
    },
    setPost: (state, action) => {
      const updatedPosts = state.posts.map((post) => {
        if (post._id === action.payload.post._id) return action.payload.post;
        return post;
      });
      state.posts = updatedPosts;
    },
    setRefreshCount: (state) => {
      state.refreshCount = state.refreshCount+1
    },
    setPropertyId: (state, action) => {
      state.property_id = action.payload
    },
    setSmartDevice: (state, action) => {
      state.smartDevice = action.payload
    },
    setTenantPayment: (state, action) => {
      state.tenantPayment = action.payload
    },
    setOccupancyId: (state, action) => {
      state.occupancy = action.payload
    },
    setCurrentTab: (state, action)=>{
      state.currentTab[action.payload.name] = action.payload.tab;
    },
  },
});

export const {
  setMode,
  setLogin,
  setLogout,
  setEinvoicingEnabled,
  setBusinessTerms,
  setTuyaToken,
  setFriends,
  setPosts,
  setSmartDevice,
  setPost,
  setRental,
  setRefreshCount,
  setPropertyId,
  setTenantPayment,
  setOccupancyId,
  setCurrentTab,
} = authSlice.actions;
export default authSlice.reducer;
